<template>
  <div class="signUp">
    <div class="personal_loginRegister comWidth" v-if="logState">
      <div class="form">
        <div class="left_box fl" style="margin-left: 0;border-right: 0;">
          <div class="register_box">
            <el-tabs v-model="activeName">
              <el-tab-pane label="中國內地用戶註冊" name="first">
                <!--内地用户-->
                <ul class="z_reg" >
                  <li>
                    <label>手機號碼</label>
                    <input type="tel" maxlength="11" v-model="tel" placeholder="11位手機號碼">
                  </li>

                  <li>
                    <label>密碼</label>
                    <input class="tbl-txt" @keyup="intensityJudge_1" v-model="passwordOne" type="password"  placeholder="6-12位数字加字母">
                  </li>
                  <li>
                    <label>密碼強度 </label>
                    <div id="level" ref="levelOne" class="qiangdu_box pw-strength">
                      <div class="pw-bar"></div>
                      <div class="pw-bar-on"></div>
                      <div class="pw-txt"></div>
                    </div>
                  </li>
                  <li>
                    <label>確認密碼 </label>
                    <input v-model="confirmPasswordOne" type="password" placeholder="請你確認密碼">
                  </li>
                  <li class="dongtai" >
                    <label>動態驗證碼 </label>
                    <input v-model="captchaOne" class="telCo" type="text" placeholder="不區分大小寫">
                    <a class="jiaZai">
                      <img :src="imgUrl"
                           v-if="ifImg_1"
                           alt="驗證碼"
                           width="100%"
                           id="imgcode"
                           @click="codeTab_1"
                      />
                      <span class="sIonUp" v-if="ifLod_1">
                        <i class="el-icon-loading" ></i>
                      </span>
                    </a>
                    <p id="z_dj" @click="codeTab_1">看不清楚？</p>
                  </li>
                  <li>
                    <label>手機驗證碼</label>
                    <input v-model="codeOne" class="telCo"  type="text" @keyup.enter="open1">

                    <a class="sendCodeBox" >
                      <b class="to_havecode" ref="toHavecodeOne" v-if="toHavecodeOne" @click="sendCodeOne()">點擊獲取</b>
                      <b class="Codecountdown" v-if="codecountdownOne">
                        <span ref="num_1">60</span>s获取
                      </b>
                    </a>
                  </li>
                  <div class="frs" >
                    <input type="checkbox" name="qued" v-model="agreeN">
                    我同意
                    <router-link :to="{name:'Agreement',query:{id:1}}" class="userXie" tag="a">《用戶協議》</router-link>
                    <router-link :to="{name:'Agreement',query:{id:2}}" class="userXie" tag="a">《隱私政策》</router-link>
                  </div>

                  <button class="register_btn" type="button" @click="open1" :disabled="dis">註冊</button>

                </ul>
              </el-tab-pane>
              <el-tab-pane  label="港澳臺及海外用戶註冊" name="second">

                <!--港澳台用户-->
                <ul class="z_reg" >
                  <li>
                    <label>郵箱</label>
                    <input type="email" name="username" v-model="email"  placeholder="郵箱" >
                  </li>

                  <li>
                    <label>密碼 </label>
                    <input @keyup="intensityJudgeTwo" class="tbl-txt" v-model="passwordTwo" ref="passwordTwo" type="password" name="password" placeholder="6-12位数字加字母">
                  </li>
                  <li>
                    <label>密碼強度 </label>
                    <div id="level" ref="levelTwo" class="qiangdu_box pw-strength">
                      <div class="pw-bar"></div>
                      <div class="pw-bar-on"></div>
                      <div class="pw-txt"></div>
                    </div>
                  </li>
                  <li>
                    <label>確認密碼</label>
                    <input type="password" v-model="confirmPasswordTwo"  placeholder="請你確認密碼">
                  </li>
                  <li class="dongtai">
                    <label>動態驗證碼</label>
                    <input class="telCo" type="text" v-model="captchaTwo"  placeholder="不區分大小寫">
                  <a class="jiaZai">
                    <img alt="驗證碼"
                         width="78px"
                         height="36px"
                         v-if="ifImg_2"
                         id="imgcode1"
                          :src="imgUrl"
                         @click="codeTab_2"
                    />
                    <span class="sIon" v-if="ifLod_2">
                        <i class="el-icon-loading" ></i>
                      </span>
                    </a>
                    <p id="z_dje" @click="codeTab_2" >看不清楚？</p>
                  </li>
                  <li>
                    <label for="">郵箱驗證碼</label>
                    <input class="telCo" type="text" name="code" v-model="codeTwo" @keyup.enter="open2">

                    <a class="sendCodeBox" >
                      <b class="to_havecode" ref="toHavecodeTwo" v-if="toHavecodeTwo" @click="sendCodeTwo()" >點擊獲取</b>
                      <b class="Codecountdown" v-if="codecountdownTwo">
                        <span ref="num_1">60</span>s获取
                      </b>
                    </a>

                  </li>
                  <div class="frs">
                    <input type="checkbox" name="qued" v-model="agreeG">
                    我同意
                    <router-link :to="{name:'Agreement',query:{id:1}}" class="userXie" tag="a">《用戶協議》</router-link>
                    <router-link :to="{name:'Agreement',query:{id:2}}" class="userXie" tag="a">《隱私政策》</router-link>
                  </div>
                  <button class="register_btn" type="button" @click="open2" :disabled="dis">註冊</button>
                </ul>

              </el-tab-pane>
            </el-tabs>

          </div>
        </div>
      </div>

      <div class="right_box fr">
        <h5>創建帳戶</h5>
        <p>
          1分鐘創建帳戶並完善個人信息，即可享受：<br>
          <i></i>安全快捷支付訂單<br>
          <i></i>隨時跟蹤訂單狀態<br>
          <i></i>即時享受积分打折優惠及新品發布信息
        </p>
        <router-link :to="{name:'SignIn'}" tag="a">已有帳戶？立即去登錄吧！</router-link>

      </div>
    </div>

    <!--导航-->
    <Nav :titles="titles" :titleChild="titleChild" :navState="navState" :tipsState="tipsState"/>

    <!--成功之后的页面跳转-->
    <div class="projectileFrame comWidth" v-if="tipState">
      <div>
        <div class="scu">注册成功</div>
        <el-row>
          <el-button type="primary" @click="continueShopping">實名認證</el-button>
          <el-button type="info" @click="returnOne">返回上一頁</el-button>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  import Nav from '@/components/Nav'
  //api
  import { signUp, verifyMessage } from '@/api/signUp';
  import {getCaptcha} from '@/api/getCode';
  import {articlesDetails} from '@/api/article';
  //common.js
  import { intensityJudge } from '@/utils/common';
  import { getToken } from '@/utils/auts'
  //md5
  import md5 from 'js-md5'
  export default {
    name: 'SignUp',
    components:{
      Nav
    },
    data () {
      return {
        //手机验证
        telRg:/^1[3,4,5,6,7,8,9]\d{9}$/,
        emailRg: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
        padReg: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/, // 密码
        activeName: 'first',
        /*导航*/
        tipsState:true,
        navState:false,
        titles: '用戶註冊',
        titleChild:[],
        /*点击获取验证码*/
        toHavecodeOne:true,
        codecountdownOne:false,

        toHavecodeTwo:true,
        codecountdownTwo:false,
        /*手机验证码*/
        telKey:'',
        telCode:'',
        /*内地用户*/
        tel:'',
        passwordOne:'',
        confirmPasswordOne:'',
        captchaOne:'',
        codeOne:'',
        /*邮箱注册*/
        email:'',//邮箱
        passwordTwo:'',//密码
        confirmPasswordTwo:'',//确认密码
        captchaTwo:'',//验证码
        codeTwo:'',
        /*邮箱验证码*/
        emailKey:'',
        emailCode:'',
        /*token*/
        access_token:'',
        token_type:'',

        isClick:true,
        /*Captcha*/
        imgUrl:'',
        captcha_key:'',
        captcha_code:'',
        //注册成功提示
        logState:true,
        tipState:false,
        //协议id
        articleData:{
          article:'89',
          include:'articlecat'
        },
        //协议列表
        agreementYong:'',
        agreementYin:'',
        //是否同意並接受协议
        agreeN:false,
        agreeG:false,
        j:null,
        dis:false,

        // 是否显示加载提示
        ifImg_1:true,
        ifLod_1:false,
        ifImg_2:true,
        ifLod_2:false,
      }
    },
    methods:{
      /*内地用户密码强弱判断*/
      intensityJudge_1(){
        var levelOne = this.$refs.levelOne;
        var passwordOne = this.passwordOne;
        intensityJudge(levelOne,passwordOne)
      },

      /*港澳台用户密码强弱判断*/
      intensityJudgeTwo(){
        var levelTwo = this.$refs.levelTwo;
        var passwordTwo = this.$refs.passwordTwo.value;
        intensityJudge(levelTwo , passwordTwo)
      },

      /*点击获取手机验证码*/
      sendCodeOne(){
          if(!(this.telRg.test(this.tel))){
            this.$message.warning('請輸入正確的手機號');
          }else if(md5((this.captchaOne).trim()) != this.captcha_code ){
            this.$message.warning('請輸入正確的動態驗證碼');
            this.captchaCode();
          }else {
            var tel = this.tel;
            var telObj = {
              username:tel,
              captcha_key:this.captcha_key,
              captcha_code:this.captchaOne,
              action:'reg'
              };
                //发送验证
              verifyMessage(telObj)
                .then(res => {
                  this.telKey = res.data.key;
                  this.telCode = res.data.code;
                  if(this.isClick){
                    this.isClick = false;
                    this.toHavecodeOne = false;
                    this.codecountdownOne = true;
                    var time_s = 60;
                    this.j = setInterval(() => {
                      time_s --;
                      this.$refs.num_1.textContent = time_s;
                      if(time_s <= 0){
                        this.isClick = true;
                        this.toHavecodeOne = true;
                        this.codecountdownOne = false;
                        window.clearInterval(this.j);
                      }
                    },1000);
                  }
                })
                .catch(err =>{
                  this.captchaCode();
                })
          }
      },

      /*点击获取邮箱验证码*/
      sendCodeTwo(){
          if(!(this.emailRg.test(this.email))){
            this.$message.warning('請輸入正確的郵箱');
          }else if(md5((this.captchaTwo).trim()) != this.captcha_code ){
            this.$message.warning('請輸入正確的動態驗證碼');
            this.captchaCode();
          }else {
            var tel = this.email;
            var telObj = {
                username:tel,
              captcha_key:this.captcha_key,
              captcha_code:this.captchaTwo,
              action:'reg'};
                //发送验证
              verifyMessage(telObj)
                .then(res => {
                  this.emailKey = res.data.key;
                  this.emailCode = res.data.code;
                  if(this.isClick){
                    this.isClick = false;
                    this.toHavecodeTwo = false;
                    this.codecountdownTwo = true;
                    var time_s = 60;
                    this.j = setInterval(() => {
                      time_s --;
                      this.$refs.num_1.textContent = time_s;
                      if(time_s <= 0){
                        this.isClick = true;
                        this.toHavecodeTwo = true;
                        this.codecountdownTwo = false;
                        window.clearInterval(this.j);
                      }
                    },1000);
                  }
                }).catch(err =>{
                  this.captchaCode();
              })
          }
      },

      /*内地用户注册验证*/
      open1() {
        var RegPara = {
          //手机号或者邮箱
          telE :(this.tel).trim(),
          //第一次输入的密码
          password :(this.passwordOne).trim(),
          //确认密码
          confirmPassword:(this.confirmPasswordOne).trim(),
          //图形动态验证码
          captcha: (this.captchaOne).trim(),
          //手机动态验证码 或者邮箱动态验证码
          code:(this.codeOne).trim(),
          key:this.telKey,
          agree:this.agreeN,
        };
        //错误提示
        var tips = {
          teE:'請輸入正確的手機號',
          paS:'6-12位數字加字母',
          paQn:'兩次輸入的密碼不一致，請重新輸入',
          coK:'請輸入正確的動態驗證碼',
          telECode:'請輸入正確的手機驗證碼',
          sle:'请选择委託協議',
        };
          this.verification(this.telRg,RegPara ,tips,this.captcha_code,this.telCode);
      },

      /*港澳台用户注册验证*/
      open2() {
        var RegPara = {
          //手机号或者邮箱
          telE :(this.email).trim(),
          //第一次输入的密码
          password :(this.passwordTwo).trim(),
          //确认密码
          confirmPassword:(this.confirmPasswordTwo).trim(),
          //图形动态验证码
          captcha: (this.captchaTwo).trim(),
          //手机动态验证码 或者邮箱动态验证码
          code:(this.codeTwo).trim(),
          key:this.emailKey,
          agree:this.agreeG,
        };
        //错误提示
        var tips = {
          teE:'請輸入正確的郵箱',
          paS:'6-12位數字加字母',
          paQn:'兩次輸入的密碼不一致，請重新輸入',
          coK:'請輸入正確的動態驗證碼',
          telECode:'請輸入正確的郵箱驗證碼',
          sle:'選擇是否同意協議',
        };
          this.verification(this.emailRg,RegPara ,tips,this.captcha_code,this.emailCode);
      },

      /*注册验证*/
      verification( Reg ,RegPara,tips,captcha_code,telCode){
        if(RegPara.telE == '' || !(Reg.test(RegPara.telE))){
          this.$message.warning(tips.teE);
        }else if(!this.padReg.test(RegPara.password)){
          this.$message.warning(tips.paS);
        }else if(RegPara.confirmPassword == '' || RegPara.password != RegPara.confirmPassword){
          this.$message.warning(tips.paQn);
        }else if(md5((RegPara.captcha).trim()) != captcha_code){
          this.$message.warning(tips.coK);
          this.captchaCode();
        }else if(md5(RegPara.code) != telCode){
          this.$message.warning(tips.telECode);
          this.captchaCode();
        }else if(RegPara.agree == false){
          this.$message.warning(tips.sle);
        }else {
            //注册
          var userObjOne = {
//            phone:this.tel,
            password:RegPara.password,
            verification_key:RegPara.key,
            verification_code:RegPara.code,
          };
          signUp(userObjOne).then(res =>{
            this.dis = true;
            window.clearInterval(this.j);
            this.signInSuccess(res);
            this.codecountdownOne = false
            this.codecountdownTwo= false
            this.toHavecodeOne= true
            this.toHavecodeTwo= true
            this.isClick = false;
          }).catch(err =>{
              this.captchaCode();
            })
        }
      },

      /*登录成功*/
      signInSuccess(res){
        this.$store.dispatch('SetToken',res.data.access_token).then(() => {}).catch(() => {});
        this.access_token = res.data.access_token;
        this.token_type = res.data.token_type;
        document.cookie = 'access_token='+ this.access_token;
        this.logState = false;
        this.tipState = true;
        //登录5秒之后的默认页面跳转
        this.defaultPage();
      },

      /*图形验证码切换*/
      codeTab_1(){
        this.ifImg_1 = false
        this.ifLod_1 = true
        this.captchaCode();
        setTimeout(() => {
          this.ifImg_1 = true
          this.ifLod_1 = false
        }, 1000);
      },
      codeTab_2(){
        this.ifImg_2 = false
        this.ifLod_2 = true
        this.captchaCode();
        setTimeout(() => {
          this.ifImg_2 = true
          this.ifLod_2 = false
        }, 1000);
      },

      /*获取动态验证码*/
      captchaCode(){
        getCaptcha().then(res =>{
          this.imgUrl = res.data.captcha_image_content
          this.captcha_key = res.data.captcha_key
          this.captcha_code = res.data.code
        }).catch(err =>{
          this.$message.warning('操作頻繁，請稍後再試')
        })
      },

      /*返回上一页*/
      returnOne(){
        var hrefW = (window.location.href).split('#')[1];
        if(hrefW == '/signIn' || hrefW == '/signUp'){
          this.$router.push({
            name:'HomePage'
          })
        }else {
          this.$router.go(-1)
        }
      },

      /*实名认证*/
      continueShopping(){
        this.$router.push({
          name:'RealName'
        })
      },

      /*获取协议内容*/
      getAgreementYong(){
        var params = {
          article:1
        }
        articlesDetails(params).then(res =>{
          this.agreementYong = (res.data.data)[0].title;
        })
      },
      getAgreementYin(){
        var params = {
          article:2
        }
        articlesDetails(params).then(res =>{
          this.agreementYin = (res.data.data)[0].title;
        })
      },
      /*判断登录状态*/
      ifSignIn(){
        if(!getToken()){
          this.logState = true;
          this.tipState = false;
        }else {
          this.logState = false;
          this.tipState = true;
        }
      },
      /*登录5秒之后的默认页面跳转*/
      defaultPage(){
        setTimeout(()=>{
          if((/signUp/).test(window.location.href)){
            this.logState = false;
            this.tipState = false;
            this.$router.push({
              name:'HomePage'
            })
          }
        },5000)
      }
    },
    mounted(){
      this.captchaCode();
      //协议内容
 /*     this.getAgreementYong();
      this.getAgreementYin();*/
      //判断登录状态
      this.ifSignIn();
      window.scrollTo(0,0)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import "../../css/signUp.less";
</style>



// WEBPACK FOOTER //
// src/pages/login/SignUp.vue